interface Props {
    label: string
    name: string
    value: string | number | boolean
    onChange: (data: HTMLInputElement) => void
    disabled: boolean
    required: boolean
    options?: OptionInterface[]
    hide?: boolean
    defaultValue?: string
}

export interface OptionInterface {
    value: string | boolean | number
    label: string
}

export const FormSelect = (props: Props) => {

    const {label, name, value, onChange, disabled, required, options, hide, defaultValue} = props

    if (hide) {
        return null
    }

    return (
        <div className="c-form-input-group__select">
            <label htmlFor={name}>{label} {required && <>*</>}</label>
            <select name={name}
                    disabled={disabled}
                    required={required}
                    value={value}
                    onChange={(data: any) => {
                        onChange(data.target)
                    }}
            >
                {defaultValue && <option value="" selected disabled>{defaultValue}</option>}

                {options?.map((option: OptionInterface) => {
                    return <option value={option.value}>{option.label}</option>
                })}
            </select>
        </div>
    )
}